import type { SVGProps } from "react"
import { extraColors } from "../utils/theme"

const SvgRadioUnselected = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 20}
    height={props.width || 20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 1c-4.968 0-9 4.032-9 9s4.032 9 9 9 9-4.032 9-9-4.032-9-9-9Zm0 16.2A7.198 7.198 0 0 1 2.8 10c0-3.978 3.222-7.2 7.2-7.2s7.2 3.222 7.2 7.2-3.222 7.2-7.2 7.2Z"
      fill={props.fill || extraColors.disabled}
    />
    <path
      d="M10 1c-4.968 0-9 4.032-9 9s4.032 9 9 9 9-4.032 9-9-4.032-9-9-9Zm0 16.2A7.198 7.198 0 0 1 2.8 10c0-3.978 3.222-7.2 7.2-7.2s7.2 3.222 7.2 7.2-3.222 7.2-7.2 7.2Z"
      fill="#000"
      fillOpacity={0.25}
    />
  </svg>
)

export default SvgRadioUnselected
